import { Link } from 'react-router';
import { usePrivy } from '@privy-io/react-auth';

interface AuthLinkProps {
  to: string;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  /** When not authenticated, show this label instead (e.g. "Connect to Explore") */
  fallbackLabel?: string;
}

/**
 * Link that requires auth. When user is not connected, opens wallet connect modal instead of navigating.
 * After connecting, user can click again to navigate.
 */
export function AuthLink({ to, className, style, children, fallbackLabel }: AuthLinkProps) {
  const { login, authenticated, ready } = usePrivy();

  if (!ready) {
    return (
      <span className={className} style={style}>
        {children}
      </span>
    );
  }

  if (authenticated) {
    return (
      <Link to={to} className={className} style={style}>
        {children}
      </Link>
    );
  }

  return (
    <button
      type="button"
      onClick={() => login()}
      className={className}
      style={style}
    >
      {fallbackLabel ?? children}
    </button>
  );
}
